<p>encoding works!</p>
<div class="navLinks">
  <ul>
    <li><a [routerLink]="['/encoding/step1']">Step1</a></li>
    <li><a [routerLink]="['/encoding/step2']">Step2</a></li>
    <li><a [routerLink]="['/encoding/step3']">Step3</a></li>
  </ul>
</div>
<router-outlet></router-outlet>
